import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
import { scrollToAnchor } from '../../utils/scroll';
import type { LegalSection } from '../../types/legal';
type LegalTocProps = {
  sections: LegalSection[];
  activeId?: string;
};
export function LegalToc({
  sections,
  activeId
}: LegalTocProps) {
  return <nav aria-label="On this page" className="sticky top-[104px] hidden max-h-[calc(100vh-128px)] overflow-y-auto pr-2 lg:block print:hidden" data-id="element-741" data-mp="1c9v3rc5bg1xz">
      <p className="text-[13px] font-semibold text-ink" data-id="element-742" data-mp="200s2fn83p2ra">On this page</p>
      <TocList sections={sections} activeId={activeId} className="mt-3 border-l border-canvas-line" data-id="element-743" data-mp="23zhqqauog4pp" />
    </nav>;
}
export function MobileToc({
  sections,
  activeId
}: LegalTocProps) {
  const [open, setOpen] = useState(false);
  return <nav aria-label="On this page" className="rounded-[12px] border border-canvas-line bg-white lg:hidden print:hidden" data-id="element-744" data-mp="2ixa4axgnyj19">
      <button type="button" aria-expanded={open} aria-controls="mobile-toc-list" onClick={() => setOpen(o => !o)} className="flex h-12 w-full items-center justify-between px-4 text-[15px] font-semibold text-ink" data-id="element-745" data-mp="2noi91g71tg83">
        On this page
        <ChevronDownIcon className={`h-4 w-4 text-ink-muted transition-transform duration-200 ease-out ${open ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-746" data-mp="dr2cey1g0l21" />
      </button>
      {open && <div id="mobile-toc-list" className="border-t border-canvas-line px-2 py-2" data-id="element-747" data-mp="np07a4dt5g3m">
          <TocList sections={sections} activeId={activeId} onSelect={() => setOpen(false)} data-id="element-748" data-mp="iqoylwz91bmz" />
        </div>}
    </nav>;
}
function TocList({
  sections,
  activeId,
  className = '',
  onSelect
}: LegalTocProps & {
  className?: string;
  onSelect?: () => void;
}) {
  return <ol className={className} data-id="element-749" data-mp="rpachets02hf">
      {sections.map((section, i) => {
      const active = section.id === activeId;
      return <li key={section.id} data-id="element-750" data-mp="2tj9roba0r3ze" data-mpi={i}>
            <a href={`#${section.id}`} aria-current={active ? 'location' : undefined} onClick={e => {
          e.preventDefault();
          scrollToAnchor(section.id);
          onSelect?.();
        }} className={`-ml-px flex gap-2.5 border-l-2 py-1.5 pl-3.5 text-[14px] leading-[1.45] transition-colors duration-150 ease-out ${active ? 'border-brand font-medium text-ink' : 'border-transparent text-ink-muted hover:text-ink'}`} data-id="element-751" data-mp="2tkb16bbdzif0">
              <span className="w-5 shrink-0 tabular-nums" data-id="element-752" data-mp="1lcis317c3uvw">{i + 1}.</span>
              {section.title}
            </a>
          </li>;
    })}
    </ol>;
}